import React from 'react';
import RichEditor from '@modules/questionnaires/complexity/richEditor';
import './richTextCellStyles.scss';
import classnames from 'classnames';

// rich editor in draggable form cell
function RichTextCell({ shouldExtend, refreshCount, typeField, ...props }) {
  const className = classnames('rich-editor-in-draggable-table', {
    expand: shouldExtend,
  });

  return (
    <div className={className}>
      <RichEditor
        key={refreshCount}
        readOnly={!shouldExtend}
        linkPopoverProps={{
          placement: 'leftTop',
        }}
        typeField={typeField}
        {...props}
      />
    </div>
  );
}

export default RichTextCell;
